module.exports = __webpack_public_path__ + "img/apple-app-store.41b367e1.svg";